export function getReorderedArray<T>(arr: Array<T>, oldIndex: number, newIndex: number): Array<T> {
  if (arr === undefined || arr === null) {
    return arr;
  }
  const element = arr[oldIndex];
  arr.splice(oldIndex, 1);
  arr.splice(newIndex, 0, element);
  return arr;
}
